/**
 * @generated SignedSource<<eeb6622dc6215d4a9739c2543b02ae0e>>
 * @relayHash d0caaa618265a97f44b5351663f887f8
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 08e302eea85e0bbea65a1a4a73aa7872d0cb0402382fdd60fd552a951294774d

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type TagUpdatesFeedAggQuery$variables = {
  containerId: string;
  shouldFetchUpdatesTabData: boolean;
  tagId: string;
};
export type TagUpdatesFeedAggQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"TagUpdatesFeedAgg">;
};
export type TagUpdatesFeedAggQuery = {
  response: TagUpdatesFeedAggQuery$data;
  variables: TagUpdatesFeedAggQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "containerId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shouldFetchUpdatesTabData"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "tagId"
},
v3 = {
  "kind": "Variable",
  "name": "containerId",
  "variableName": "containerId"
},
v4 = {
  "kind": "Variable",
  "name": "tagId",
  "variableName": "tagId"
},
v5 = {
  "kind": "Literal",
  "name": "first",
  "value": 10
},
v6 = [
  (v3/*: any*/),
  (v5/*: any*/),
  (v4/*: any*/)
],
v7 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v8 = {
  "kind": "ScalarField",
  "name": "id"
},
v9 = {
  "kind": "ScalarField",
  "name": "uuid"
},
v10 = {
  "kind": "ScalarField",
  "name": "canCommentOnUpdates"
},
v11 = {
  "kind": "ScalarField",
  "name": "canEditUpdates"
},
v12 = {
  "kind": "ScalarField",
  "name": "key"
},
v13 = {
  "kind": "ScalarField",
  "name": "name"
},
v14 = {
  "kind": "ScalarField",
  "name": "isArchived"
},
v15 = {
  "kind": "ScalarField",
  "name": "summary"
},
v16 = {
  "kind": "ScalarField",
  "name": "description"
},
v17 = [
  (v8/*: any*/),
  (v15/*: any*/),
  {
    "concreteType": "TownsquareUpdateNoteConnection",
    "kind": "LinkedField",
    "name": "updateNotes",
    "plural": false,
    "selections": [
      {
        "concreteType": "TownsquareUpdateNoteEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "concreteType": "TownsquareUpdateNote",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              (v15/*: any*/),
              (v16/*: any*/),
              (v8/*: any*/)
            ]
          }
        ]
      }
    ]
  }
],
v18 = {
  "kind": "ScalarField",
  "name": "url"
},
v19 = {
  "kind": "ScalarField",
  "name": "canCreateUpdates"
},
v20 = {
  "kind": "ScalarField",
  "name": "ari"
},
v21 = {
  "kind": "ScalarField",
  "name": "missedUpdate"
},
v22 = {
  "kind": "ScalarField",
  "name": "updateType"
},
v23 = {
  "kind": "ScalarField",
  "name": "picture"
},
v24 = {
  "kind": "ScalarField",
  "name": "accountId"
},
v25 = {
  "kind": "ScalarField",
  "name": "label"
},
v26 = {
  "kind": "ScalarField",
  "name": "start"
},
v27 = {
  "concreteType": "TownsquareTargetDateRange",
  "kind": "LinkedField",
  "name": "dateRange",
  "plural": false,
  "selections": [
    (v26/*: any*/),
    {
      "kind": "ScalarField",
      "name": "end"
    }
  ]
},
v28 = [
  (v25/*: any*/),
  (v27/*: any*/)
],
v29 = {
  "concreteType": "TownsquareTargetDate",
  "kind": "LinkedField",
  "name": "newDueDate",
  "plural": false,
  "selections": (v28/*: any*/)
},
v30 = [
  {
    "alias": "projectValue",
    "kind": "ScalarField",
    "name": "value"
  }
],
v31 = {
  "kind": "LinkedField",
  "name": "lastEditedBy",
  "plural": false,
  "selections": [
    (v7/*: any*/),
    (v24/*: any*/),
    (v13/*: any*/),
    (v8/*: any*/)
  ]
},
v32 = {
  "kind": "ScalarField",
  "name": "creationDate"
},
v33 = {
  "kind": "ScalarField",
  "name": "editDate"
},
v34 = [
  (v8/*: any*/)
],
v35 = [
  {
    "kind": "LinkedField",
    "name": "node",
    "plural": false,
    "selections": [
      (v7/*: any*/),
      {
        "kind": "InlineFragment",
        "selections": [
          (v8/*: any*/),
          (v13/*: any*/),
          (v24/*: any*/),
          (v23/*: any*/)
        ],
        "type": "AtlassianAccountUser"
      },
      {
        "kind": "InlineFragment",
        "selections": (v34/*: any*/),
        "type": "AppUser"
      },
      {
        "kind": "InlineFragment",
        "selections": (v34/*: any*/),
        "type": "CustomerUser"
      }
    ]
  },
  (v8/*: any*/)
],
v36 = {
  "concreteType": "TownsquareTargetDate",
  "kind": "LinkedField",
  "name": "oldDueDate",
  "plural": false,
  "selections": (v28/*: any*/)
},
v37 = {
  "kind": "ScalarField",
  "name": "newTargetDate"
},
v38 = {
  "kind": "ScalarField",
  "name": "newTargetDateConfidence"
},
v39 = {
  "kind": "ScalarField",
  "name": "archived"
},
v40 = {
  "concreteType": "TownsquareUpdateNoteConnection",
  "kind": "LinkedField",
  "name": "updateNotes",
  "plural": false,
  "selections": [
    {
      "concreteType": "TownsquareUpdateNoteEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "concreteType": "TownsquareUpdateNote",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v8/*: any*/),
            (v15/*: any*/),
            (v16/*: any*/),
            (v39/*: any*/)
          ]
        }
      ]
    }
  ]
},
v41 = {
  "kind": "TypeDiscriminator",
  "abstractKey": "__isTownsquareHighlight"
},
v42 = [
  (v7/*: any*/),
  (v23/*: any*/),
  (v13/*: any*/),
  (v24/*: any*/),
  (v8/*: any*/)
],
v43 = {
  "kind": "LinkedField",
  "name": "creator",
  "plural": false,
  "selections": (v42/*: any*/)
},
v44 = {
  "kind": "LinkedField",
  "name": "lastEditedBy",
  "plural": false,
  "selections": (v42/*: any*/)
},
v45 = {
  "kind": "ScalarField",
  "name": "lastEditedDate"
},
v46 = {
  "kind": "ClientExtension",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "__id"
    }
  ]
},
v47 = {
  "concreteType": "TownsquareHighlightConnection",
  "kind": "LinkedField",
  "name": "highlights",
  "plural": false,
  "selections": [
    {
      "concreteType": "TownsquareHighlightEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v15/*: any*/),
            (v16/*: any*/),
            (v7/*: any*/),
            (v8/*: any*/),
            (v41/*: any*/),
            (v43/*: any*/),
            (v44/*: any*/),
            (v32/*: any*/),
            (v45/*: any*/)
          ]
        }
      ]
    },
    (v46/*: any*/)
  ]
},
v48 = {
  "concreteType": "TownsquareCommentConnection",
  "kind": "LinkedField",
  "name": "comments",
  "plural": false,
  "selections": [
    {
      "concreteType": "TownsquareCommentEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "concreteType": "TownsquareComment",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v8/*: any*/),
            {
              "kind": "LinkedField",
              "name": "creator",
              "plural": false,
              "selections": [
                (v7/*: any*/),
                (v13/*: any*/),
                (v8/*: any*/),
                (v24/*: any*/),
                (v23/*: any*/)
              ]
            },
            {
              "kind": "ScalarField",
              "name": "commentText"
            },
            (v33/*: any*/),
            (v32/*: any*/)
          ]
        }
      ]
    },
    (v46/*: any*/)
  ]
},
v49 = {
  "kind": "ScalarField",
  "name": "value"
},
v50 = {
  "kind": "ScalarField",
  "name": "startValue"
},
v51 = {
  "kind": "ScalarField",
  "name": "targetValue"
},
v52 = {
  "kind": "ScalarField",
  "name": "scoringMode"
},
v53 = [
  (v49/*: any*/)
],
v54 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "messageId"
    },
    {
      "kind": "ScalarField",
      "name": "defaultValue"
    }
  ],
  "type": "TownsquareLocalizationField"
},
v55 = {
  "kind": "LinkedField",
  "name": "name",
  "plural": false,
  "selections": [
    (v7/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": (v53/*: any*/),
      "type": "TownsquareGoalTypeCustomName"
    },
    (v54/*: any*/)
  ]
},
v56 = {
  "kind": "LinkedField",
  "name": "namePlural",
  "plural": false,
  "selections": [
    (v7/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": (v53/*: any*/),
      "type": "TownsquareGoalTypeCustomNamePlural"
    },
    (v54/*: any*/)
  ]
},
v57 = {
  "kind": "ScalarField",
  "name": "type"
},
v58 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 50
  }
],
v59 = {
  "kind": "ScalarField",
  "name": "percentage"
},
v60 = {
  "concreteType": "TownsquareGoalProgress",
  "kind": "LinkedField",
  "name": "progress",
  "plural": false,
  "selections": [
    (v59/*: any*/),
    (v57/*: any*/)
  ]
},
v61 = {
  "kind": "ScalarField",
  "name": "subType"
},
v62 = {
  "kind": "ScalarField",
  "name": "source"
},
v63 = {
  "kind": "ScalarField",
  "name": "time"
},
v64 = {
  "concreteType": "TownsquareMetricValue",
  "kind": "LinkedField",
  "name": "latestValue",
  "plural": false,
  "selections": [
    (v63/*: any*/),
    (v8/*: any*/)
  ]
},
v65 = {
  "concreteType": "TownsquareMetricTargetConnection",
  "kind": "LinkedField",
  "name": "metricTargets",
  "plural": false,
  "selections": [
    {
      "concreteType": "TownsquareMetricTargetEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "concreteType": "TownsquareMetricTarget",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v8/*: any*/),
            {
              "concreteType": "TownsquareMetric",
              "kind": "LinkedField",
              "name": "metric",
              "plural": false,
              "selections": [
                (v8/*: any*/),
                (v13/*: any*/),
                (v57/*: any*/),
                (v61/*: any*/),
                (v39/*: any*/),
                {
                  "kind": "ScalarField",
                  "name": "externalEntityId"
                },
                (v62/*: any*/),
                (v64/*: any*/)
              ]
            },
            {
              "concreteType": "TownsquareMetricValue",
              "kind": "LinkedField",
              "name": "snapshotValue",
              "plural": false,
              "selections": [
                (v49/*: any*/),
                (v8/*: any*/)
              ]
            },
            (v50/*: any*/),
            (v51/*: any*/)
          ]
        }
      ]
    }
  ]
},
v66 = {
  "concreteType": "TownsquareTargetDate",
  "kind": "LinkedField",
  "name": "targetDate",
  "plural": false,
  "selections": [
    (v27/*: any*/)
  ]
},
v67 = [
  (v7/*: any*/),
  (v24/*: any*/),
  (v13/*: any*/),
  (v23/*: any*/),
  (v8/*: any*/)
],
v68 = {
  "kind": "LinkedField",
  "name": "owner",
  "plural": false,
  "selections": (v67/*: any*/)
},
v69 = {
  "kind": "ScalarField",
  "name": "score"
},
v70 = {
  "kind": "LinkedField",
  "name": "creator",
  "plural": false,
  "selections": (v67/*: any*/)
},
v71 = [
  (v32/*: any*/),
  {
    "concreteType": "TownsquareGoalState",
    "kind": "LinkedField",
    "name": "newState",
    "plural": false,
    "selections": [
      (v49/*: any*/),
      (v69/*: any*/),
      (v25/*: any*/)
    ]
  },
  (v15/*: any*/),
  (v70/*: any*/),
  (v40/*: any*/),
  {
    "concreteType": "TownsquareHighlightConnection",
    "kind": "LinkedField",
    "name": "highlights",
    "plural": false,
    "selections": [
      {
        "concreteType": "TownsquareHighlightEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              (v7/*: any*/),
              (v8/*: any*/),
              (v15/*: any*/),
              (v16/*: any*/),
              (v41/*: any*/),
              (v43/*: any*/),
              (v44/*: any*/),
              (v32/*: any*/),
              (v45/*: any*/)
            ]
          }
        ]
      },
      (v46/*: any*/)
    ]
  },
  (v8/*: any*/)
],
v72 = {
  "concreteType": "TownsquareGoalUpdate",
  "kind": "LinkedField",
  "name": "latestUserUpdate",
  "plural": false,
  "selections": (v71/*: any*/)
},
v73 = {
  "concreteType": "TownsquareGoalTypeIcon",
  "kind": "LinkedField",
  "name": "icon",
  "plural": false,
  "selections": [
    (v12/*: any*/)
  ]
},
v74 = [
  (v49/*: any*/),
  (v69/*: any*/)
],
v75 = {
  "concreteType": "TownsquareStatus",
  "kind": "LinkedField",
  "name": "status",
  "plural": false,
  "selections": (v74/*: any*/)
},
v76 = [
  (v5/*: any*/)
],
v77 = [
  {
    "concreteType": "TownsquareGoalUpdateEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "concreteType": "TownsquareGoalUpdate",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v21/*: any*/),
          (v22/*: any*/),
          (v15/*: any*/),
          (v33/*: any*/),
          (v32/*: any*/),
          (v8/*: any*/)
        ]
      }
    ]
  }
],
v78 = [
  (v49/*: any*/),
  (v63/*: any*/),
  (v8/*: any*/)
],
v79 = [
  (v57/*: any*/),
  (v59/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "name": "TagUpdatesFeedAggQuery",
    "selections": [
      {
        "args": [
          (v3/*: any*/),
          {
            "kind": "Variable",
            "name": "shouldFetchUpdatesTabData",
            "variableName": "shouldFetchUpdatesTabData"
          },
          (v4/*: any*/)
        ],
        "kind": "FragmentSpread",
        "name": "TagUpdatesFeedAgg"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "TagUpdatesFeedAggQuery",
    "selections": [
      {
        "condition": "shouldFetchUpdatesTabData",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": (v6/*: any*/),
            "concreteType": "TownsquareUpdateConnection",
            "kind": "LinkedField",
            "name": "statusUpdates_byTag",
            "plural": false,
            "selections": [
              {
                "concreteType": "TownsquareUpdateEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v7/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v8/*: any*/),
                          {
                            "concreteType": "TownsquareProject",
                            "kind": "LinkedField",
                            "name": "project",
                            "plural": false,
                            "selections": [
                              (v8/*: any*/),
                              {
                                "kind": "ScalarField",
                                "name": "watching"
                              },
                              (v9/*: any*/),
                              {
                                "concreteType": "TownsquareProjectCapabilities",
                                "kind": "LinkedField",
                                "name": "capabilities",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "name": "canWatchProject"
                                  },
                                  (v10/*: any*/),
                                  (v11/*: any*/)
                                ]
                              },
                              {
                                "kind": "ScalarField",
                                "name": "isPrivate"
                              },
                              {
                                "concreteType": "TownsquareIconURIs",
                                "kind": "LinkedField",
                                "name": "iconUrl",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "TownsquareThemeURIs",
                                    "kind": "LinkedField",
                                    "name": "square",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "kind": "ScalarField",
                                        "name": "light"
                                      },
                                      {
                                        "kind": "ScalarField",
                                        "name": "dark"
                                      },
                                      {
                                        "kind": "ScalarField",
                                        "name": "transparent"
                                      }
                                    ]
                                  }
                                ]
                              },
                              (v12/*: any*/),
                              (v13/*: any*/),
                              (v14/*: any*/),
                              {
                                "kind": "ScalarField",
                                "name": "startDate"
                              },
                              {
                                "concreteType": "TownsquareProjectUpdate",
                                "kind": "LinkedField",
                                "name": "latestUserUpdate",
                                "plural": false,
                                "selections": (v17/*: any*/)
                              },
                              (v18/*: any*/),
                              {
                                "concreteType": "TownsquareProjectCapabilities",
                                "kind": "LinkedField",
                                "name": "capabilities",
                                "plural": false,
                                "selections": [
                                  (v19/*: any*/)
                                ]
                              }
                            ]
                          },
                          (v20/*: any*/),
                          (v21/*: any*/),
                          (v22/*: any*/),
                          (v15/*: any*/),
                          {
                            "kind": "LinkedField",
                            "name": "creator",
                            "plural": false,
                            "selections": [
                              (v7/*: any*/),
                              (v13/*: any*/),
                              (v23/*: any*/),
                              (v8/*: any*/),
                              (v24/*: any*/)
                            ]
                          },
                          (v29/*: any*/),
                          {
                            "concreteType": "TownsquareProjectState",
                            "kind": "LinkedField",
                            "name": "newState",
                            "plural": false,
                            "selections": (v30/*: any*/)
                          },
                          (v31/*: any*/),
                          (v32/*: any*/),
                          (v33/*: any*/),
                          (v18/*: any*/),
                          {
                            "concreteType": "GraphStoreSimplifiedUserViewedProjectUpdateInverseConnection",
                            "kind": "LinkedField",
                            "name": "viewers",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "GraphStoreSimplifiedUserViewedProjectUpdateInverseEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": (v35/*: any*/)
                              }
                            ]
                          },
                          {
                            "concreteType": "TownsquareProjectState",
                            "kind": "LinkedField",
                            "name": "oldState",
                            "plural": false,
                            "selections": (v30/*: any*/)
                          },
                          (v36/*: any*/),
                          (v37/*: any*/),
                          (v38/*: any*/),
                          (v40/*: any*/),
                          (v47/*: any*/),
                          (v48/*: any*/)
                        ],
                        "type": "TownsquareProjectUpdate"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v8/*: any*/),
                          {
                            "concreteType": "TownsquareGoal",
                            "kind": "LinkedField",
                            "name": "goal",
                            "plural": false,
                            "selections": [
                              (v8/*: any*/),
                              {
                                "kind": "ScalarField",
                                "name": "isWatching"
                              },
                              (v9/*: any*/),
                              {
                                "concreteType": "TownsquareGoalCapabilities",
                                "kind": "LinkedField",
                                "name": "capabilities",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "name": "canWatchGoal"
                                  },
                                  (v19/*: any*/),
                                  (v11/*: any*/),
                                  {
                                    "kind": "ScalarField",
                                    "name": "canDeleteUpdates"
                                  },
                                  (v10/*: any*/)
                                ]
                              },
                              {
                                "concreteType": "TownsquareGoal",
                                "kind": "LinkedField",
                                "name": "parentGoal",
                                "plural": false,
                                "selections": (v34/*: any*/)
                              },
                              (v12/*: any*/),
                              (v13/*: any*/),
                              {
                                "concreteType": "TownsquareGoalIcon",
                                "kind": "LinkedField",
                                "name": "icon",
                                "plural": false,
                                "selections": [
                                  (v12/*: any*/),
                                  {
                                    "kind": "ScalarField",
                                    "name": "appearance"
                                  }
                                ]
                              },
                              {
                                "concreteType": "TownsquareMetricTargetConnection",
                                "kind": "LinkedField",
                                "name": "metricTargets",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "TownsquareMetricTargetEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "concreteType": "TownsquareMetricTarget",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "concreteType": "TownsquareMetric",
                                            "kind": "LinkedField",
                                            "name": "metric",
                                            "plural": false,
                                            "selections": [
                                              (v8/*: any*/),
                                              (v39/*: any*/)
                                            ]
                                          },
                                          {
                                            "concreteType": "TownsquareMetricTargetPeriodConnection",
                                            "kind": "LinkedField",
                                            "name": "metricTargetPeriods",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "concreteType": "TownsquareMetricTargetPeriodEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                  {
                                                    "concreteType": "TownsquareMetricTargetPeriod",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                      {
                                                        "concreteType": "TownsquareTargetDate",
                                                        "kind": "LinkedField",
                                                        "name": "date",
                                                        "plural": false,
                                                        "selections": [
                                                          {
                                                            "concreteType": "TownsquareTargetDateRange",
                                                            "kind": "LinkedField",
                                                            "name": "dateRange",
                                                            "plural": false,
                                                            "selections": [
                                                              (v26/*: any*/)
                                                            ]
                                                          }
                                                        ]
                                                      },
                                                      (v49/*: any*/)
                                                    ]
                                                  }
                                                ]
                                              }
                                            ]
                                          },
                                          (v8/*: any*/),
                                          (v50/*: any*/),
                                          (v51/*: any*/)
                                        ]
                                      }
                                    ]
                                  }
                                ]
                              },
                              (v52/*: any*/),
                              (v39/*: any*/),
                              {
                                "concreteType": "TownsquareGoalType",
                                "kind": "LinkedField",
                                "name": "goalType",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "TownsquareGoalType",
                                    "kind": "LinkedField",
                                    "name": "successMeasure",
                                    "plural": false,
                                    "selections": [
                                      (v55/*: any*/),
                                      (v56/*: any*/),
                                      (v8/*: any*/)
                                    ]
                                  },
                                  (v8/*: any*/)
                                ]
                              },
                              {
                                "concreteType": "TownsquareGoalProgress",
                                "kind": "LinkedField",
                                "name": "progress",
                                "plural": false,
                                "selections": [
                                  (v57/*: any*/)
                                ]
                              },
                              {
                                "args": (v58/*: any*/),
                                "concreteType": "TownsquareGoalConnection",
                                "kind": "LinkedField",
                                "name": "successMeasures",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "TownsquareGoalEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "concreteType": "TownsquareGoal",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                          (v8/*: any*/),
                                          (v13/*: any*/),
                                          (v39/*: any*/),
                                          (v60/*: any*/),
                                          (v65/*: any*/),
                                          (v18/*: any*/),
                                          (v52/*: any*/),
                                          (v66/*: any*/),
                                          (v68/*: any*/),
                                          (v72/*: any*/),
                                          (v9/*: any*/),
                                          (v14/*: any*/),
                                          {
                                            "concreteType": "TownsquareGoalType",
                                            "kind": "LinkedField",
                                            "name": "goalType",
                                            "plural": false,
                                            "selections": [
                                              (v55/*: any*/),
                                              (v56/*: any*/),
                                              (v73/*: any*/),
                                              (v8/*: any*/)
                                            ]
                                          },
                                          (v75/*: any*/),
                                          {
                                            "args": (v76/*: any*/),
                                            "concreteType": "TownsquareGoalUpdateConnection",
                                            "kind": "LinkedField",
                                            "name": "updates",
                                            "plural": false,
                                            "selections": (v77/*: any*/),
                                            "storageKey": "updates(first:10)"
                                          }
                                        ]
                                      },
                                      (v7/*: any*/)
                                    ]
                                  }
                                ],
                                "storageKey": "successMeasures(first:50)"
                              },
                              {
                                "concreteType": "TownsquareGoalConnection",
                                "kind": "LinkedField",
                                "name": "subGoals",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "TownsquareGoalEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "concreteType": "TownsquareGoal",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                          (v8/*: any*/),
                                          (v13/*: any*/),
                                          (v39/*: any*/),
                                          (v60/*: any*/),
                                          {
                                            "concreteType": "TownsquareGoalType",
                                            "kind": "LinkedField",
                                            "name": "goalType",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "kind": "ScalarField",
                                                "name": "kind"
                                              },
                                              (v8/*: any*/),
                                              (v73/*: any*/)
                                            ]
                                          },
                                          (v65/*: any*/),
                                          (v18/*: any*/),
                                          (v52/*: any*/),
                                          (v66/*: any*/),
                                          (v68/*: any*/),
                                          (v72/*: any*/),
                                          (v14/*: any*/),
                                          (v75/*: any*/),
                                          {
                                            "args": [
                                              {
                                                "kind": "Literal",
                                                "name": "first",
                                                "value": 30
                                              }
                                            ],
                                            "concreteType": "TownsquareGoalUpdateConnection",
                                            "kind": "LinkedField",
                                            "name": "updates",
                                            "plural": false,
                                            "selections": (v77/*: any*/),
                                            "storageKey": "updates(first:30)"
                                          }
                                        ]
                                      }
                                    ]
                                  }
                                ]
                              },
                              {
                                "args": (v76/*: any*/),
                                "concreteType": "TownsquareGoalUpdateConnection",
                                "kind": "LinkedField",
                                "name": "updates",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "TownsquareGoalUpdateEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "concreteType": "TownsquareGoalUpdate",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": (v17/*: any*/)
                                      }
                                    ]
                                  }
                                ],
                                "storageKey": "updates(first:10)"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "canPostUpdate"
                              },
                              (v14/*: any*/),
                              {
                                "kind": "ScalarField",
                                "name": "canEditUpdate"
                              }
                            ]
                          },
                          (v21/*: any*/),
                          (v22/*: any*/),
                          (v32/*: any*/),
                          (v15/*: any*/),
                          {
                            "concreteType": "TownsquareGoalState",
                            "kind": "LinkedField",
                            "name": "newState",
                            "plural": false,
                            "selections": (v74/*: any*/)
                          },
                          (v37/*: any*/),
                          (v38/*: any*/),
                          (v40/*: any*/),
                          (v47/*: any*/),
                          {
                            "concreteType": "TownsquareGoalMetricUpdateConnection",
                            "kind": "LinkedField",
                            "name": "metricUpdate",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "TownsquareGoalMetricUpdateEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "concreteType": "TownsquareGoalMetricUpdate",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "concreteType": "TownsquareMetric",
                                        "kind": "LinkedField",
                                        "name": "metric",
                                        "plural": false,
                                        "selections": [
                                          (v8/*: any*/),
                                          (v13/*: any*/),
                                          (v57/*: any*/),
                                          (v61/*: any*/),
                                          (v39/*: any*/),
                                          (v62/*: any*/),
                                          (v64/*: any*/),
                                          {
                                            "args": [
                                              {
                                                "kind": "Literal",
                                                "name": "first",
                                                "value": 100
                                              },
                                              {
                                                "kind": "Literal",
                                                "name": "sort",
                                                "value": [
                                                  "TIME_DESC"
                                                ]
                                              }
                                            ],
                                            "concreteType": "TownsquareMetricValueConnection",
                                            "kind": "LinkedField",
                                            "name": "values",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "concreteType": "TownsquareMetricValueEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                  {
                                                    "concreteType": "TownsquareMetricValue",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": (v78/*: any*/)
                                                  }
                                                ]
                                              }
                                            ],
                                            "storageKey": "values(first:100,sort:[\"TIME_DESC\"])"
                                          }
                                        ]
                                      },
                                      {
                                        "concreteType": "TownsquareMetricValue",
                                        "kind": "LinkedField",
                                        "name": "newValue",
                                        "plural": false,
                                        "selections": (v78/*: any*/)
                                      },
                                      {
                                        "concreteType": "TownsquareMetricValue",
                                        "kind": "LinkedField",
                                        "name": "oldValue",
                                        "plural": false,
                                        "selections": [
                                          (v63/*: any*/),
                                          (v8/*: any*/),
                                          (v49/*: any*/)
                                        ]
                                      },
                                      {
                                        "kind": "ScalarField",
                                        "name": "newStartValue"
                                      },
                                      {
                                        "kind": "ScalarField",
                                        "name": "newTargetValue"
                                      }
                                    ]
                                  }
                                ]
                              }
                            ]
                          },
                          (v70/*: any*/),
                          (v29/*: any*/),
                          {
                            "concreteType": "TownsquareGoalProgress",
                            "kind": "LinkedField",
                            "name": "newProgress",
                            "plural": false,
                            "selections": (v79/*: any*/)
                          },
                          (v31/*: any*/),
                          (v33/*: any*/),
                          {
                            "concreteType": "GraphStoreSimplifiedUserViewedGoalUpdateInverseConnection",
                            "kind": "LinkedField",
                            "name": "viewers",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "GraphStoreSimplifiedUserViewedGoalUpdateInverseEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": (v35/*: any*/)
                              }
                            ]
                          },
                          (v18/*: any*/),
                          (v20/*: any*/),
                          (v48/*: any*/),
                          {
                            "concreteType": "TownsquareGoalState",
                            "kind": "LinkedField",
                            "name": "oldState",
                            "plural": false,
                            "selections": (v74/*: any*/)
                          },
                          (v36/*: any*/),
                          {
                            "args": (v58/*: any*/),
                            "concreteType": "TownsquareGoalBundledUpdateConnection",
                            "kind": "LinkedField",
                            "name": "bundledUpdates",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "TownsquareGoalBundledUpdateEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "concreteType": "TownsquareGoalUpdate",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": (v71/*: any*/)
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "nodeMissingReason"
                                  },
                                  {
                                    "concreteType": "TownsquareGoal",
                                    "kind": "LinkedField",
                                    "name": "goal",
                                    "plural": false,
                                    "selections": [
                                      (v8/*: any*/),
                                      (v13/*: any*/),
                                      {
                                        "concreteType": "TownsquareGoalProgress",
                                        "kind": "LinkedField",
                                        "name": "progress",
                                        "plural": false,
                                        "selections": (v79/*: any*/)
                                      },
                                      (v65/*: any*/),
                                      (v18/*: any*/),
                                      (v52/*: any*/),
                                      (v66/*: any*/),
                                      (v68/*: any*/)
                                    ]
                                  }
                                ]
                              }
                            ],
                            "storageKey": "bundledUpdates(first:50)"
                          }
                        ],
                        "type": "TownsquareGoalUpdate"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": (v34/*: any*/),
                        "type": "Node",
                        "abstractKey": "__isNode"
                      }
                    ]
                  },
                  (v7/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "cursor"
                  }
                ]
              },
              {
                "concreteType": "PageInfo",
                "kind": "LinkedField",
                "name": "pageInfo",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "endCursor"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "hasNextPage"
                  }
                ]
              }
            ]
          },
          {
            "args": (v6/*: any*/),
            "filters": [
              "tagId",
              "containerId"
            ],
            "handle": "connection",
            "key": "TagUpdatesFeedAgg_statusUpdates_byTag",
            "kind": "LinkedHandle",
            "name": "statusUpdates_byTag"
          }
        ]
      }
    ]
  },
  "params": {
    "id": "08e302eea85e0bbea65a1a4a73aa7872d0cb0402382fdd60fd552a951294774d",
    "metadata": {},
    "name": "TagUpdatesFeedAggQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "574ebd0ce42de226d24c5233c3ba2a9b";

export default node;
